import parse from 'html-react-parser';

const BLOCK_TAG_REGEX =
   /(<\/?(?:address|article|aside|blockquote|dd|div|dl|dt|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hr|li|main|nav|ol|option|p|pre|section|table|tbody|td|tfoot|th|thead|tr|ul|video)\b[^>]*>)/gi;

export const formatNewlines = (str) => {
   if (!str || typeof str !== 'string') return str;

   // 1. Unescape literal string escapes '\r\n' and '\n'
   const text = str.replace(/\\r\\n/g, '\r\n').replace(/\\n/g, '\n');

   // 2. Split text into parts around block-level HTML tags
   const parts = text.split(BLOCK_TAG_REGEX);

   const resultParts = parts.map((part, index) => {
      // If this part is a block-level HTML tag, keep it as is
      BLOCK_TAG_REGEX.lastIndex = 0;
      if (BLOCK_TAG_REGEX.test(part)) {
         BLOCK_TAG_REGEX.lastIndex = 0;
         return part;
      }
      BLOCK_TAG_REGEX.lastIndex = 0;

      const prevIsBlock = index > 0;
      const nextIsBlock = index < parts.length - 1;

      let chunk = part;

      // Remove leading newlines if preceded by a block HTML tag
      if (prevIsBlock) {
         chunk = chunk.replace(/^[\r\n]+/, '');
      }

      // Remove trailing newlines if followed by a block HTML tag
      if (nextIsBlock) {
         chunk = chunk.replace(/[\r\n]+$/, '');
      }

      // Replace remaining inline newlines with <br />
      return chunk.replace(/\r\n/g, '<br />').replace(/\n/g, '<br />');
   });

   return resultParts.join('');
};

export const parseContent = (content, options) => {
   if (!content) return content;
   if (typeof content !== 'string') return content;
   return parse(formatNewlines(content), options);
};

export default parseContent;
